import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const {
    isLoggedIn,
    password,
    useremail,
    setUserEmail,
    setPassword,
    handleLogin,
  } = useAuth();

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/');
    } else {
      navigate('/login');
    }
  }, [isLoggedIn, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <>
      <div className="container-xxl login-bgImage" style={{
        minHeight: '100vh',
        background: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div className="authentication-wrapper authentication-basic container-p-y" style={{ width: '100%', maxWidth: '450px' }}>
          <div className="authentication-inner">
            <div className="card" style={{
              border: 'none',
              borderRadius: '16px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
              overflow: 'hidden',
              background: 'white'
            }}>
              <div style={{
                background: '#696cff',
                padding: '30px',
                textAlign: 'center',
                color: 'white'
              }}>
                <div style={{
                  width: '70px',
                  height: '70px',
                  margin: '0 auto 15px',
                  background: 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '35px'
                }}>
                  📱
                </div>
                <h3 className="mb-1" style={{ color: 'white', fontWeight: '700', fontSize: '24px' }}>
                  Mobile City
                </h3>
                <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '14px', margin: 0 }}>
                  Welcome back! Please sign in
                </p>
              </div>
              <div className="card-body" style={{ padding: '40px', background: 'white' }}>
                <form onSubmit={handleSubmit} style={{ background: 'white' }}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label" style={{ 
                      color: '#333', 
                      fontWeight: '600',
                      fontSize: '14px',
                      marginBottom: '8px'
                    }}>
                      Email or Username
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      name="email-username"
                      placeholder="Enter your email or username"
                      autoFocus=""
                      value={useremail}
                      onChange={(e) => setUserEmail(e.target.value)}
                      style={{
                        padding: '12px 15px',
                        borderRadius: '8px',
                        border: '2px solid #e0e0e0',
                        fontSize: '14px',
                        transition: 'all 0.3s ease'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#696cff';
                        e.target.style.boxShadow = '0 0 0 0.2rem rgba(105, 108, 255, 0.15)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e0e0e0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                  <div className="mb-3 form-password-toggle">
                    <div className="d-flex justify-content-between">
                      <label className="form-label" htmlFor="password" style={{ 
                        color: '#333', 
                        fontWeight: '600',
                        fontSize: '14px',
                        marginBottom: '8px'
                      }}>
                        Password
                      </label>
                    </div>
                    <div className="input-group input-group-merge">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        id="password"
                        className="form-control"
                        name="password"
                        placeholder="Enter your password"
                        aria-describedby="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                          padding: '12px 15px',
                          borderRadius: '8px',
                          border: '2px solid #e0e0e0',
                          fontSize: '14px',
                          borderRight: 'none',
                          borderTopRightRadius: '0',
                          borderBottomRightRadius: '0',
                          transition: 'all 0.3s ease'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#696cff';
                          e.target.style.boxShadow = '0 0 0 0.2rem rgba(105, 108, 255, 0.15)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#e0e0e0';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                      <span 
                        className="input-group-text cursor-pointer" 
                        onClick={togglePasswordVisibility}
                        style={{
                          border: '2px solid #e0e0e0',
                          borderLeft: 'none',
                          background: '#fff',
                          cursor: 'pointer',
                          padding: '12px 15px',
                          color: '#696cff',
                          fontSize: '13px',
                          fontWeight: '600',
                          borderRadius: '8px',
                          borderTopLeftRadius: '0',
                          borderBottomLeftRadius: '0',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.background = '#fff'}
                      >
                        {showPassword ? 'Hide' : 'Show'}
                      </span>
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="remember-me"
                        style={{ cursor: 'pointer' }}
                      />
                      <label className="form-check-label" htmlFor="remember-me" style={{ 
                        color: '#666', 
                        fontSize: '14px',
                        cursor: 'pointer'
                      }}>
                        Remember Me
                      </label>
                    </div>
                  </div>
                  <div className="mb-3">
                    <button 
                      className="btn btn-primary d-grid w-100" 
                      type="submit" 
                      style={{
                        padding: '12px',
                        borderRadius: '8px',
                        fontSize: '16px',
                        fontWeight: '600',
                        background: '#696cff',
                        border: 'none',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 15px rgba(105, 108, 255, 0.3)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 6px 20px rgba(105, 108, 255, 0.4)';
                        e.target.style.background = '#5a5de8';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 15px rgba(105, 108, 255, 0.3)';
                        e.target.style.background = '#696cff';
                      }}
                    >
                      Sign in
                    </button>
                  </div>
                </form>
                <div>
                  <ToastContainer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
